import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Select, NavLink as Link } from 'components/common';

import useLogout from 'utils/hooks/useLogout';
import {
  setCurrentStore,
  setSearchAll,
  removeSearchAll,
} from 'utils/selectors';
import { makeOption, makeOptions, makeStore } from 'utils/helpers';
import { routes, allStoresOption } from 'utils/constants';
import { useData } from 'utils/context';

const makeStoreOptions = (stores) => {
  const options = makeOptions(stores);
  if (options.length < 2) return options;
  return [allStoresOption, ...options];
};

const Navbar = () => {
  const {
    user,
    currentStore,
    searchAll,
    dispatchSearchAll,
    dispatchCurrentStore,
  } = useData();
  const logout = useLogout();
  const [photoUrl, setPhotoUrl] = useState('/images/sb-logo.png');
  const storeOptions = user ? makeStoreOptions(user?.stores) : [];
  const [defaultStoreOption, setDefaultOption] = useState(
    searchAll ? allStoresOption : makeOption(currentStore)
  );
  useEffect(() => {
    if (user && user?.photoUrl) setPhotoUrl(user?.photoUrl);
  }, [user]);
  useEffect(() => {
    setDefaultOption(searchAll ? allStoresOption : makeOption(currentStore));
  }, [searchAll, currentStore]);
  return (
    <Wrapper>
      <LeftPane>
        <Image src={photoUrl} alt="profile" width="78" height="78" />
        <Select
          value={defaultStoreOption}
          instanceId="store-selector"
          classNamePrefix="store-selector"
          options={storeOptions}
          placeholder={'Select Store...'}
          onChange={(selectedStoreOption) => {
            const selectedStore = makeStore(selectedStoreOption);
            if (selectedStoreOption.value === allStoresOption.value) {
              dispatchSearchAll(true);
              setSearchAll();
            } else {
              dispatchSearchAll(false);
              dispatchCurrentStore(selectedStore);
              setCurrentStore(selectedStore);
              removeSearchAll();
            }
          }}
        />
      </LeftPane>
      <RightPane>
        <Link href={routes.home} activeClassName="active">
          <a>Open</a>
        </Link>
        <Link href={routes.closed} activeClassName="active">
          <a>Closed</a>
        </Link>
        <LogoutBtn onClick={() => logout.start()} />
      </RightPane>
    </Wrapper>
  );
};

export default Navbar;

export const Wrapper = styled.div`
  /* border: 1px solid red; */
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 3px solid #eaeaea;
`;

export const LeftPane = styled.div`
  /* border: 1px solid blue; */
  display: flex;
  align-items: center;
  img {
    /* border: 1px solid blue; */
    margin-right: 32px;
    border-radius: 50%;
  }
`;
export const RightPane = styled.div`
  /* border: 1px solid green; */
  a {
    font-style: normal;
    font-family: 'Overpass', sans-serif;
    font-weight: bold;
    font-size: 30px;
    line-height: 41px;
    margin-bottom: -3px;
    display: inline-block;
    color: #6c6c6c;
    padding: 10px 10px 24px 10px;
  }
  .active {
    color: #3f76e6;
    border-bottom: 3px solid #3f76e6;
  }
`;
export const LogoutBtn = styled.button`
  margin-left: 16px;
  margin-right: 32px;
  border: none;
  background-color: transparent;
  width: 28px;
  height: 28px;
  &:before {
    display: inline-block;
    content: url('/icons/log-out.svg');
    width: 28px;
    height: 28px;
  }
`;

export const Image = styled.img`
  object-fit: contain;
`;
